module.exports = __webpack_public_path__ + "static/media/vt_logo.c4ab9bb9.png";